var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreesAlt7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9777 3.57774C14.7147 2.10364 16.8183 2.10364 17.5554 3.57774L22.3193 13.1056C22.9842 14.4354 22.0172 16 20.5305 16H16.5165V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H15.7736C15.7712 22.75 15.7689 22.75 15.7665 22.75C15.7642 22.75 15.7618 22.75 15.7595 22.75H8.00696C8.00461 22.75 8.00226 22.75 7.99991 22.75C7.99756 22.75 7.99521 22.75 7.99286 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H7.24991V18H3.23598C1.74921 18 0.782226 16.4354 1.44712 15.1056L6.21106 5.57774C6.94811 4.10364 9.05172 4.10364 9.78876 5.57774L14.5527 15.1056C15.2176 16.4354 14.2506 18 12.7638 18H8.74991V21.25H15.0165V18.6821C16.1837 17.6947 16.6643 15.9748 15.8943 14.4348L12.2217 7.0896L13.9777 3.57774Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesAlt7);
export default __webpack_public_path__ + "static/media/trees-alt-7.4cfdaffbded93615967924bf04355b7a.svg";
export { ForwardRef as ReactComponent };